var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge inline-flex items-center px-3 py-0.5 rounded-full text-sm font-bold",class:_vm.settings},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }